exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-1a04a568]{margin:0;color:#fff;text-transform:uppercase;font-size:19px;margin-bottom:20px}.button-group[data-v-1a04a568]{margin-top:0}.form-field.disabled[data-v-1a04a568]{opacity:.25}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a04a568","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/users/UserRegister.vue
// module id = ohfz
// module chunks = 0 1